import React from 'react';
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import PublicationCard from '../../components/publicationCard/publicationCard.component';
import PublicationsPageCover from '../../assets/images/banners/about-intro.png';
// import CoverImage from '../../assets/images/publications/cover-1.png';
import PublicationCatMenu from '../publications/publicationCatMenu.component';
import PageHeader from '../../components/pageHeader/pageHeader.component';

const PublicationCategoryPage = props => {

    const { publications } = useSelector(state => state.all)

    const { category } = useParams()

    return (

        <React.Fragment>

            <PageHeader
                title="গাইড এবং প্রশ্নব্যাংক"
            />
            <div className="PublicationsPage-module__publication-list-section">
                <Container className='bg-light mb-5' fluid>
                    <PublicationCatMenu />
                </Container>
                <Container>
                    <Row>
                        {publications && publications.map(item =>
                            item.categories.map(cat => {
                                if (cat.name === category) {
                                    return <Col xs={12} md={4} lg={3}>
                                        <PublicationCard item={item} />
                                    </Col>
                                }
                            })
                        )}
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default PublicationCategoryPage;